<script>
  //
  // Pure
  //
  import { registerMoveEvent } from "./helpers";
  export let items: any[] = [];
  export let itemsPerPage: number = 1;
  export let gap: number = 20;

  let cur = 0;
  let sliderTranslate: string;

  $: sliderTranslate = `calc(-${100 * cur}% - ${gap * itemsPerPage * cur}px)`;

  const count = items.length / itemsPerPage;
  const dotsArray = new Array(Math.ceil(count));

  const leftSwipe = () => (cur = Math.min(cur + 1, count - 1));
  const rightSwipe = () => (cur = Math.max(cur - 1, 0));
  const registerMove = (node: HTMLElement) =>
    registerMoveEvent(node, leftSwipe, rightSwipe);
</script>

<div class="slider" use:registerMove>
  <div
    class="slide-inside"
    style="transform: translateX({sliderTranslate}); column-gap: {gap}px;"
  >
    {#each items as item}
      <slot {item} />
    {/each}
  </div>

  {#if dotsArray && dotsArray.length > 1}
    <div class="dots">
      {#each dotsArray as _, index}
        <div class="dot" class:active={Math.ceil(cur) === index} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .slider {
    overflow: hidden;
    width: 100%;
  }
  .slide-inside {
    display: flex;
    align-items: flex-start;
    transition: 0.2s ease-out;
  }
  .dots {
    display: flex;
    justify-content: center;
  }
  .dot {
    width: 14px;
    height: 14px;
    margin: 0 4px;
    border-radius: 50%;
    border: 2px solid inherit;
  }
  .dot.active {
    background-color: inherit;
  }
</style>
